import { postApi } from './fetchApi'
import { paths } from './generated/gdpr'

type GDPRWithdrawConsent = paths['/gdpr/withdrawConsent']
type GDPRWithdrawConsentMethod = GDPRWithdrawConsent['post']
type GDPRWithdrawConsentBody =
  GDPRWithdrawConsentMethod['parameters']['body']['body']
type GDPRWithdrawConsentResponse = GDPRWithdrawConsentMethod['responses']['204']

type GDPRGiveConsent = paths['/gdpr/giveConsent']
type GDPRGiveConsentMethod = GDPRGiveConsent['post']
type GDPRGiveConsentBody = GDPRGiveConsentMethod['parameters']['body']['body']
type GDPRGiveConsentResponse = GDPRGiveConsentMethod['responses']['204']

type GDPRRejectAgreement = paths['/gdpr/rejectAgreement']
type GDPRRejectAgreementMethod = GDPRRejectAgreement['post']
type GDPRRejectAgreementBody =
  GDPRRejectAgreementMethod['parameters']['body']['body']
export type GDPRRejectAgreementResponse =
  GDPRRejectAgreementMethod['responses']['204']

export const recallGdprApi = (
  language: string,
  lexeme: string,
  password: string
) =>
  postApi<GDPRWithdrawConsentResponse, GDPRWithdrawConsentBody>(
    '/gdpr/withdrawConsent',
    {
      language,
      password,
      lexeme,
      applicationVersion: '1',
    }
  )

export const giveConsentGdprApi = (language: string, lexeme: string) =>
  postApi<GDPRGiveConsentResponse, GDPRGiveConsentBody>('/gdpr/giveConsent', {
    language,
    lexeme,
    applicationVersion: '1',
  })

export const rejectAgreementGdprApi = (
  language: string,
  lexeme: string,
  password?: string
) =>
  postApi<GDPRRejectAgreementResponse, GDPRRejectAgreementBody>(
    '/gdpr/rejectAgreement',
    {
      language,
      password,
      lexeme,
      applicationVersion: '1',
    }
  )
